import React from 'react';
import EphemeralFlashMessage from './EphemeralFlashMessage';
import ModalFlashMessage from './ModalFlashMessage';
var FlashMessage = function FlashMessage(_ref) {
  var message = _ref.message,
    dismissMessage = _ref.dismissMessage;
  if (message.modal) {
    return /*#__PURE__*/React.createElement(ModalFlashMessage, {
      message: message,
      dismissMessage: dismissMessage
    });
  }
  return /*#__PURE__*/React.createElement(EphemeralFlashMessage, {
    dismissMessage: dismissMessage,
    message: message
  });
};
export default FlashMessage;